import React from 'react'
import styled from 'styled-components'
import { AddCardModalText } from 'src/components/Global/Text/TitleText'
import { InvestModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const InvestWrapperModal = styled.div`
  padding-top: 43px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  width: 100%;
  .investList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid ${({ theme }) => theme.colors.gray};
  }
  .bottom {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 22px;
    color: ${({ theme }) => theme.colors.gray};
  }
  h2 {
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 22px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .true {
    margin-top: 20px;
  }
  .text {
    margin-bottom: 50px;
  }
  .top {
    margin-top: 150px;
  }
`
const ReviewInvestment = () => {
  let location = useLocation()
  return (
    <InvestWrapperModal>
      <AddCardModalText className="text">
        Review Your Investment
      </AddCardModalText>
      <div className="investList">
        <p>Units</p>
        <h2>10 Units</h2>
      </div>
      <div className="investList">
        <p>Value</p>
        <h2>N50,000</h2>
      </div>
      <div className="investList">
        <p>Processing Fee (1.5%)</p>
        <h2>+ N750</h2>
      </div>
      <div className="investList bottom">
        <p>Total</p>
        <h2>N50,750</h2>
      </div>
      <p className="true">
        Please note this investment can only be claimed after the expect yield
        date is due which is in 6 months’ time.
      </p>
      <div className="top">
        <Link
          to={`/big/investment-confirmation`}
          state={{ backgroundLocation: location }}
        >
          <InvestModalButton>Continue</InvestModalButton>
        </Link>
      </div>
    </InvestWrapperModal>
  )
}

export { ReviewInvestment }
